import { render, staticRenderFns } from "./table-budget-effect.vue?vue&type=template&id=a70890a6&scoped=true&"
import script from "./table-budget-effect.vue?vue&type=script&lang=ts&"
export * from "./table-budget-effect.vue?vue&type=script&lang=ts&"
import style0 from "./table-budget-effect.vue?vue&type=style&index=0&id=a70890a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70890a6",
  null
  
)

export default component.exports